// 账单状态 1待确认账单、2账单更新中、3付款中、4已完成
export const BILL_STATUS = {
  TO_CONFIRM: 1,
  UPDATING: 2,
  PAYING: 3,
  COMPLETE: 4,
}
export const BILL_STATUS_TEXT = {
  [BILL_STATUS.TO_CONFIRM]: '待确认账单',
  [BILL_STATUS.UPDATING]: '账单更新中',
  [BILL_STATUS.PAYING]: '付款中',
  [BILL_STATUS.COMPLETE]: '已完成',
}

// 开票状态 0未开票、1开票中、2已开票、3开票失败
export const INVOICING_STATUS = {
  NOT_INVOICED: 0,
  INVOICING: 1,
  INVOICED: 2,
  INVOICE_FAILED: 3,
}
export const INVOICING_STATUS_TEXT = {
  [INVOICING_STATUS.NOT_INVOICED]: '未开票',
  [INVOICING_STATUS.INVOICING]: '开票中',
  [INVOICING_STATUS.INVOICED]: '已开票',
  [INVOICING_STATUS.INVOICE_FAILED]: '开票失败',
}

// 付款方式 1线上扣款,2线下对公转账
export const PAY_MODE = {
  ONLINE: 1,
  OFFLINE: 2,
}
export const PAY_MODE_TEXT = {
  [PAY_MODE.ONLINE]: '线上扣款',
  [PAY_MODE.OFFLINE]: '线下对公转账',
}
